import React from 'react';

import Tag from '@atlaskit/tag/removable-tag';

export default (): React.JSX.Element => <Tag text="Removable tag" removeButtonLabel="Remove" />;
